module.exports = __webpack_public_path__ + "static/nagoya-castle-map-aa9ccca88591b23f6d476d0dae3abe67.jpg";